import { api } from "@/api/client";
import type { AuthUser } from "@/api/queries/auth/types";
import { queryKeys } from "@/api/queryKeys";
import { ACCESS_TOKEN } from "@/constants/auth";
import { useQuery } from "@tanstack/react-query";

export const useMe = () => {
  const getMe = async () => {
    if (!localStorage.getItem(ACCESS_TOKEN)) {
      return null;
    }
    return api.get("/auth/me").then((res) => res.data);
  };

  return useQuery<{ success: boolean; data: AuthUser }>({
    queryKey: [queryKeys.me],
    queryFn: getMe,
  });
};

export const useGetLinkGoogleAccount = (enabled?: boolean) => {
  return useQuery<{ url: string }>({
    enabled,
    queryKey: [queryKeys.getLinkGoogleAccount],
    queryFn: async () => api.get("/auth/link-google-account").then((res) => res.data),
  });
};
